import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADDRESS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const NeighbourhoodList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.string, show: false },
			{ Header: 'name', accessor: 'name', filterType: FilterType.string, showOnMobile: true },
			{
				Header: 'country',
				accessor: 'countryName',
				filterType: FilterType.string,
				showOnMobile: true,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY
			},
			{ Header: 'city', accessor: 'cityName', filterType: FilterType.string, showOnMobile: true },
			{ Header: 'state', accessor: 'stateName', filterType: FilterType.string, show: false },
			{ Header: 'district', accessor: 'districtName', filterType: FilterType.string, showOnMobile: true },
			{ Header: 'countryID', accessor: 'countryID', filterType: FilterType.string, show: false },
			{ Header: 'stateID', accessor: 'stateID', filterType: FilterType.string, show: false },
			{ Header: 'cityID', accessor: 'cityID', filterType: FilterType.string, show: false },
			{ Header: 'districtID', accessor: 'districtID', filterType: FilterType.string, show: false }
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.NEIGHBORHOODS}
				columns={columns}
				fetchUrl={ADDRESS.GET_NEIGHBORHOODS_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.SUPPORT}
				exportName="neighbourhoods"
			/>
		</TabTableContainer>
	);
};

export default NeighbourhoodList;
